// extracted by mini-css-extract-plugin
export default {"toggle":"LanguageToggle_toggle__fP4mn","flag":"LanguageToggle_flag__XLHs4","label":"LanguageToggle_label__QapU-"};